__turbopack_context__.v({
  "benefits": "VEK0BG_benefits",
  "col6": "VEK0BG_col6",
  "freeBox": "VEK0BG_freeBox",
  "role": "VEK0BG_role",
  "roleDropdown": "VEK0BG_roleDropdown",
  "sectionHeader": "VEK0BG_sectionHeader",
  "tagline": "VEK0BG_tagline",
  "top6": "VEK0BG_top6",
  "wrapper5": "VEK0BG_wrapper5",
});
